/* Name:Chaitali Khachane
   Description:This is home file, in this file we will show the list of domain if user select domain card or data asset 
   if user select data Asset card with its description
   User will able to navigate the domainlist, dataAsset list, single dataAsset or single domain according to user selection
*/


import { useMsal } from '@azure/msal-react';
import axios from "axios";
import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { Message } from "primereact/message";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from "primereact/tooltip";
import { Fragment, useEffect, useRef, useState } from "react";
import { FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DataAssestsLogo from "../../assests/AssetsImage.png";
import Cube from "../../assests/Cube.svg";
import LogoImg from "../../assests/MarsPetcareLogo2.png";
import WireframeCube from "../../assests/WireframeCube.svg";
import { loginRequest } from "../../auth.config";
import { ActionText } from "../../component/outerFrame/headerStyle";
import { SET_NOTIFICATION_ARRAY } from "../../redux/crumbs/crumbs.type";
import { SET_API_DATA, SET_FORM_VALUE } from "../../redux/dataDomain/dataDomain.type";
import { getAssetOwner, getDataDomainSubdomain, getdataProducts, getHomedataAssets } from "../../redux/home/home.action";
import { theme } from "../../theme/theme";
import { ActiveDataCard, CurtainStyle, DataCardHeading, DataCardValue, DataDisplayCard, DataDisplayCardHeader, DataDisplayCardNav, DataDisplayCardValue, DisplayData, DisplayDataHeading, HomeContainer, ImageContainer, LabelSubText, LabelText, NavPage, NonActiveDataCard, StripedOverlayStyle } from "./homeStyle";
import "./homeStyle.css";
import Header from '../../nav/Header';
import HomePage from './HomePage';


function Home() {



    const { apiData: {
        dataAssests, domainSubDomain
    } } = useSelector((state) => state.home)
    const { accounts, instance } = useMsal();
    const { apiData } = useSelector((state) => state.home)
    const [activeCard, setActiveCard] = useState("Assets")
    const [startIndex, setStartIndex] = useState(0)
    const [endIndex, setEndIndex] = useState(3)
    const [forwardButtonDisabled, setForwardButtonDisabled] = useState(false)
    const [backwardButtonDisabled, setBackwardButtonDisabled] = useState(false)
    const [photo, setPhoto] = useState(null);
    const menuLeft = useRef(null);
    const bellMenu = useRef(null);

    const navigate = useNavigate();

    const dispatch = useDispatch()
    const { sessionData } = useSelector((state) => state.crumbs)
    const [countNoti, setCountNoti] = useState(0);

    const handleLogout = () => {
        instance.logoutRedirect().then(() => {
            console.log("Logged out successfully");
        }).catch(error => {
            console.error("Logout failed:", error);
        });
    };
    //this function will render the data Asset card with its description
    //when we click on View All Asset this function will navigate to the dataAssets page
    const getDataAssetsCardData = () => {
        return <Fragment>
            <DataCardHeading>Data Assets</DataCardHeading>
            <DataCardValue style={{ height: "80%", overflow: "auto" }}>
                A data asset is any data that holds value to an organization and is managed as a resource. It can include raw data, processed datasets, structured or unstructured data, and other forms of information that are used to support business processes, decision-making, or analysis.

            </DataCardValue>
            <NavPage className="handCursor" onClick={() => { navigate("/dataAssets") }}>View All Assets  <i style={{ fontSize: "10px", paddingRight: "10px" }} className="pi pi-arrow-right" /></NavPage>
        </Fragment>
    }


    //this function will render the data Domain card with its description
    //when we click on View All Domain this function will navigate to the dataDomain page
    const getDomainCardData = () => {
        return <Fragment>
            <DataCardHeading>Data Domains</DataCardHeading>
            <DataCardValue style={{ height: "80%", overflow: "auto" }}>
                A data product is a consumption-ready set of high-quality, trustworthy, and accessible data that people across an organization can use to solve business challenges.
            </DataCardValue>
            <NavPage className="handCursor" onClick={() => {
                dispatch({
                    type: SET_FORM_VALUE,
                    payload: {
                        formField: "domainActiveIndex",
                        value: 0
                    }
                })
                // dispatch({
                //     type: SET_API_DATA,
                //     payload: {
                //         apiField: "supplyDomain",
                //         data: apiData.domainSubDomain.data.filter((val1) => val1.domain_name === "Supply")[0],
                //         status: "success",
                //     },
                // })
                // dispatch({
                //     type: SET_API_DATA,
                //     payload: {
                //         apiField: "masterDataDomain",
                //         data: apiData.domainSubDomain.data.filter((val1) => val1.domain_name === "MasterData")[0],
                //         status: "success",
                //     },
                // })
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "demandDomain",
                        data: apiData.domainSubDomain.data.filter((val1) => val1.domain_name === "Sales")[0],
                        status: "success",
                    },
                })
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "rNDDomain",
                        data: apiData.domainSubDomain.data.filter((val1) => val1.domain_name === "Marketing")[0],
                        status: "success",
                    },
                })
                navigate("/dataDomain")
            }}>View All Domains <i style={{ fontSize: "10px", paddingRight: "10px" }} className="pi pi-arrow-right" /></NavPage>
        </Fragment>
    }
    const getProfilePhoto = async () => {
        try {
            // Ensure you acquire a token for the signed-in user
            const response = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],  // Use the first account from the authenticated accounts
            });

            const token = response.accessToken;

            // Fetch the profile photo
            const photoResponse = await axios.get(
                'https://graph.microsoft.com/v1.0/me/photo/$value',
                {
                    headers: {
                        Authorization: `Bearer ${token}`,  // Pass the token in the Authorization header
                    },
                    responseType: 'arraybuffer',  // To receive the image as binary data
                }
            );

            const blob = new Blob([photoResponse.data], { type: 'image/jpeg' });
            const imageUrl = URL.createObjectURL(blob);
            setPhoto(imageUrl);
        } catch (err) {
            console.error('Error fetching profile photo', err);
        }
    };
    const getBellNotification = () => {
        // let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
        let displayMessages = []
        if (sessionData.bellNotification !== null && sessionData.bellNotification.length !== 0) {
            sessionData.bellNotification.map((val, index1) => {
                // let match = 0
                // sessionData.bellNotification.map((val1, index2) => {

                //     if (val === val1 && index1 > index2) {
                //         match = 1
                //     }
                // })
                // if (match === 0) {
                displayMessages.push({ label: <Message severity="info" text={<span style={{ padding: "0", margin: "0", fontSize: "11px" }}>{val}</span>} /> })
                // }
            })
            return [
                {
                    // label: localStorage.getItem("userName"),
                    items: displayMessages
                }
            ]
        } else {
            return [
                {
                    label: "No Notification available",
                    // items: displayMessages
                }
            ]
        }



    }

    //this hook is used to get list of data Asset anf data Domain from API call
    useEffect(() => {
        let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
        dispatch({
            type: SET_NOTIFICATION_ARRAY,
            payload: {
                value: tempArray
            }
        })
        dispatch(getHomedataAssets())
        dispatch(getdataProducts())
        dispatch(getDataDomainSubdomain())
        dispatch(getAssetOwner())

    }, [])
    useEffect(() => {
        console.log('account', instance.getActiveAccount())
        sessionStorage.setItem('bellNotification', JSON.stringify([]));
        localStorage.setItem('idToken', instance.getActiveAccount().idToken);
        localStorage.setItem('userName', instance.getActiveAccount().name);
        localStorage.setItem('userId', instance.getActiveAccount().username);
        getProfilePhoto()
    }, [instance])
    useEffect(() => {
        setCountNoti(sessionData.bellNotification?.length)
    }, [sessionData.bellNotification])
    return (
        <Fragment>
            <Header/>
            {/* {
                dataAssests.loading || domainSubDomain.loading ?
                    <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div> :
                    <HomeContainer style={{ width: "calc(100% - 56px)", height: "calc(100% - 80px)" }}>
                        <div className="grid" style={{ margin: "0px", height: "60px", width: "100%" }}>
                            <div className="col-6" >

                                <img style={{ position: "absolute", zIndex: "2", margin: "5px 28px", height: "45px" }} src={LogoImg} />

                            </div>
                            <div style={{ padding: "0px", paddingRight: "30px", paddingTop: "11px", textAlign: "right", height: "100%" }} class="col-6">
                                <Tooltip target=".custom-target-tooltip" content="Under construction, please check back soon" position="left" />
                                <ActionText className=" custom-target-tooltip">
                                    Rule Elevation
                                </ActionText>
                                <span class="vertical-divider"></span>
                                <ActionText className="handCursor custom-target-tooltip">
                                    FAQ’s
                                </ActionText>
                                <span class="vertical-divider"></span>
                                <ActionText className="handCursor custom-target-tooltip">
                                    Insights
                                </ActionText>
                                <span class="vertical-divider"></span>

                                <ActionText className="handCursor custom-target-tooltip">
                                    Request
                                </ActionText>

                                <span class="vertical-divider"></span>
                                <Menu model={getBellNotification()
                                } style={{ width: "200px", maxHeight: "40%", overflow: "auto", padding: "0", margin: "0" }} popup ref={bellMenu} id="popup_menu_bell" />

                                <ActionText
                                    aria-controls="popup_menu_bell" aria-haspopup
                                    onClick={(event) => bellMenu.current.toggle(event)}
                                    className="handCursor">
                                    <i className="pi pi-bell" shape="circle" />
                                </ActionText>
                                <Menu model={[
                                    {
                                        label: localStorage.getItem("userName"),
                                        items: [
                                            {
                                                label: 'Access Management',
                                                command: () => {
                                                    navigate("/accessManagement")
                                                }
                                            },
                                            {
                                                label: 'Logout',
                                                command: () => {
                                                    handleLogout()
                                                }
                                            },
                                            {
                                                label: <span style={{ overflowWrap: "anywhere" }}>{localStorage.getItem("userId")}</span>,
                                              
                                            }
                                        ]
                                    }
                                ]
                                } popup ref={menuLeft} id="popup_menu_left" />
                                <Tooltip target=".avatar-target-icon" />
                                <Avatar className="avatar-target-icon handCursor"
                                    image={photo}
                                    data-pr-tooltip={localStorage.getItem("userName")}
                                    data-pr-position="bottom"
                                    aria-controls="popup_menu_left" aria-haspopup
                                    onClick={(event) => menuLeft.current.toggle(event)}
                                    style={{ verticalAlign: "top", top: "4px", position: "relative", backgroundColor: "#cbcbcb" }} icon={<FaUser />} shape="circle" />

                            </div>

                        </div>
                        <ImageContainer>
                            <img style={{ width: "13%", position: "fixed", margin: "0", padding: "0", top: "10%", right: "30%", pointerEvents: 'none' }} src={WireframeCube} />
                            <img style={{ width: "33%", position: "fixed", margin: "0", padding: "0", right: "28px" }} class="background-image" src={Cube} />
                        </ImageContainer>
                        <div className="grid" style={{ margin: "0px", height: "calc(100% - 60px)" }}>

                            <div className="col-6" style={{ backgroundColor: "white", padding: "0px", height: "100%" }}>
                                <CurtainStyle>
                                    <StripedOverlayStyle>
                                        <div style={{ paddingLeft: "3%", height: "43.9%" }}>
                                            <LabelText>
                                                <div> Snacking </div>
                                                <div> Data Quality Accelerator </div>
                                            </LabelText>
                                            <LabelSubText>
                                                <div> Providing a comprehensive and intuitive report, giving users an at-a-glance view of the quality of various data assets.</div>
                                            </LabelSubText>
                                        </div>
                                        <div className="grid" style={{ margin: "0px", height: "56.1%" }}>
                                            <div className="col-6" style={{ paddingLeft: "30px" }}>
                                                {activeCard === "Assets" ? <ActiveDataCard>
                                                    {getDataAssetsCardData()}
                                                </ActiveDataCard> :
                                                    <NonActiveDataCard onClick={() => {
                                                        setStartIndex(0)
                                                        setEndIndex(3)
                                                        setActiveCard("Assets")
                                                    }
                                                    } >
                                                        {getDataAssetsCardData()}
                                                    </NonActiveDataCard>}
                                            </div>
                                            <div className="col-6">
                                                {activeCard === "Domains" ? <ActiveDataCard>
                                                    {getDomainCardData()}
                                                </ActiveDataCard> :
                                                    <NonActiveDataCard onClick={() => {
                                                        setStartIndex(0)
                                                        setEndIndex(3)
                                                        setActiveCard("Domains")
                                                    }
                                                    }>
                                                        {getDomainCardData()}
                                                    </NonActiveDataCard>}
                                            </div>
                                        </div>


                                    </StripedOverlayStyle>
                                </CurtainStyle>
                            </div>
                            <div className="col-6" style={{ alignContent: "end", padding: "0px", height: "100%" }}>
                                <DisplayData>
                                    <DisplayDataHeading>{`Recently Added ${activeCard}`}</DisplayDataHeading>
                                    <div className="grid" style={{ height: "85%" }}>
                                        {activeCard === "Assets" ?
                                            [...dataAssests.data].sort((a, b) => new Date(b.created_date) - new Date(a.created_date)).slice(startIndex, endIndex).map((val) => {
                                                return <div className="col-4" style={{ height: "100%", marginTop: "5px" }}>
                                                    <DataDisplayCard onClick={() => { navigate(`/dataAsset/${val.data_asset_id}`) }}>
                                                        <img src={DataAssestsLogo} style={{ margin: "5px 0 0 15px", width: "25px" }} />
                                                        <Tooltip target=".dataDisplayCardHeader" />
                                                        <DataDisplayCardHeader style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: "calc(100% - 55px)", display: "inline-block" }} className="dataDisplayCardHeader" data-pr-tooltip={val.data_asset_name}>{val.data_asset_name}</DataDisplayCardHeader>
                                                        <div style={{ height: "60%", overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            <Tooltip target=".dataAssetsDescription" />
                                                            <span className="dataAssetsDescription" data-pr-tooltip={val.description}><DataDisplayCardValue style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{val.description}</DataDisplayCardValue></span>
                                                        </div>
                                                        <DataDisplayCardNav className="handCursor" onClick={() => { navigate(`/dataAsset/${val.data_asset_id}`) }}> View Detail <i style={{ fontSize: "10px", paddingRight: "10px", marginTop: "5px" }} className="pi pi-arrow-right" /></DataDisplayCardNav>
                                                    </DataDisplayCard>
                                                </div>
                                            })
                                            : [...domainSubDomain.data].slice(startIndex, endIndex).map((val) => {
                                                return <div className="col-4" style={{ height: "100%", marginTop: "5px" }}>
                                                    <DataDisplayCard>
                                                        <img src={DataAssestsLogo} style={{ margin: "5px 0 0 15px", width: "25px" }} />
                                                        <Tooltip target=".dataDisplayCardHeader" />

                                                        <DataDisplayCardHeader className="dataDisplayCardHeader" data-pr-tooltip={val.domain_name}>{val.domain_name}</DataDisplayCardHeader>
                                                        <div style={{ height: "60%", overflow: 'hidden', textOverflow: 'ellipsis', width: "calc(100% - 55px)", display: "inline-block" }}>
                                                            <Tooltip target=".dataAssetsDescription" />
                                                            <span className="dataAssetsDescription" data-pr-tooltip={val.description}><DataDisplayCardValue>{val.description}</DataDisplayCardValue></span>
                                                        </div>
                                                        <DataDisplayCardNav onClick={() => {
                                                          
                                                            if (val.domain_name === "Sales") {
                                                                dispatch({
                                                                    type: SET_FORM_VALUE,
                                                                    payload: {
                                                                        formField: "domainActiveIndex",
                                                                        value: 0
                                                                    }
                                                                })
                                                            }
                                                            if (val.domain_name === "Marketing") {
                                                                dispatch({
                                                                    type: SET_FORM_VALUE,
                                                                    payload: {
                                                                        formField: "domainActiveIndex",
                                                                        value: 1
                                                                    }
                                                                })
                                                            }

                                                         
                                                            dispatch({
                                                                type: SET_API_DATA,
                                                                payload: {
                                                                    apiField: "demandDomain",
                                                                    data: apiData.domainSubDomain.data.filter((val1) => val1.domain_name === "Sales")[0],
                                                                    status: "success",
                                                                },
                                                            })
                                                            dispatch({
                                                                type: SET_API_DATA,
                                                                payload: {
                                                                    apiField: "rNDDomain",
                                                                    data: apiData.domainSubDomain.data.filter((val1) => val1.domain_name === "Marketing")[0],
                                                                    status: "success",
                                                                },
                                                            })
                                                            navigate("/dataDomain")

                                                        }} className="handCursor"> View Detail <i style={{ fontSize: "10px", paddingRight: "10px", marginTop: "5px" }} className="pi pi-arrow-right" /></DataDisplayCardNav>
                                                    </DataDisplayCard>
                                                </div>
                                            })}
                                    </div>
                                    <div style={{ textAlign: "end", marginRight: "15px" }}>
                                        <i onClick={() => {
                                            if (startIndex === 0) {

                                            } else {
                                                setStartIndex(startIndex - 3)
                                                setEndIndex(endIndex - 3)
                                            }

                                        }}


                                            style={{ marginRight: "10px", color: startIndex === 0 ? theme.colors.disabledColor : theme.colors.primary }} className="handCursor pi pi-arrow-left" /><i
                                            onClick={() => {
                                                if (activeCard === "Assets") {
                                                    if (endIndex >= dataAssests.data.length - 1) {

                                                    } else {
                                                        setStartIndex(startIndex + 3)
                                                        setEndIndex(endIndex + 3)

                                                    }
                                                } else if (activeCard === "Domains") {
                                                    if (endIndex >= domainSubDomain.data.length - 1) {

                                                    } else {
                                                        setStartIndex(startIndex + 3)
                                                        setEndIndex(endIndex + 3)
                                                    }
                                                }

                                            }}

                                            style={{
                                                color: activeCard === "Assets" ?
                                                    (endIndex >= dataAssests.data.length - 1 ? theme.colors.disabledColor : theme.colors.primary) :
                                                    (endIndex >= domainSubDomain.data.length - 1 ? theme.colors.disabledColor : theme.colors.primary)
                                            }} className="handCursor pi pi-arrow-right" /></div>
                                </DisplayData>

                            </div>
                        </div>

                    </HomeContainer>
            } */}

            <HomePage/>
        </Fragment>

    )
}
export default Home;
